import { Loader2, XCircle } from "lucide-react";

function CancelOnPosButton({ onCancel, cancelling }) {
  if (!onCancel) return null;
  return (
    <button
      type="button"
      onClick={onCancel}
      disabled={cancelling}
      className="shrink-0 inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-bold rounded-md border border-red-300 bg-white text-red-600 hover:bg-red-50 disabled:opacity-60 transition-colors"
      data-testid="cancel-card-payment-btn"
    >
      {cancelling ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <XCircle className="w-3.5 h-3.5" />}
      {cancelling ? "Cancelling…" : "Cancel"}
    </button>
  );
}

function ProcessingBody({ title, subtitle, onCancel, cancelling, testId }) {
  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 space-y-2 overflow-hidden" data-testid={testId}>
      <div className="flex items-center gap-3">
        <Loader2 className="w-5 h-5 text-blue-600 animate-spin shrink-0" />
        <div className="flex-1 min-w-0">
          <p className="font-bold text-sm text-blue-800 truncate">{title}</p>
          <p className="text-xs text-blue-600">{subtitle}</p>
        </div>
        <CancelOnPosButton onCancel={onCancel} cancelling={cancelling} />
      </div>
      <div className="w-full bg-blue-200 rounded-full h-1.5 overflow-hidden">
        <div className="h-1.5 rounded-full bg-blue-600 animate-pulse" style={{ width: '100%' }} />
      </div>
    </div>
  );
}

const WAITING = "Waiting for terminal — Cancel here or on the PIN pad";

export function ProcessingIndicator({ processingType, onCancel, cancelling }) {
  return (
    <ProcessingBody title={`Processing ${processingType?.replace('_', ' ')}...`} subtitle={cancelling ? "Cancelling on terminal…" : WAITING}
      onCancel={onCancel} cancelling={cancelling} testId="processing-indicator" />
  );
}

export function QuickPayView({ processing, processingType, paymentResult, onCancel, cancelling }) {
  if (paymentResult) {
    return (
      <div className={`p-3 rounded-lg flex items-center gap-2 ${paymentResult.approved ? 'bg-green-50 border border-green-200' : 'bg-red-50 border border-red-200'}`}>
        {paymentResult.approved ? (
          <svg className="w-6 h-6 text-green-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" /></svg>
        ) : (
          <svg className="w-6 h-6 text-red-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10" /><line x1="15" y1="9" x2="9" y2="15" /><line x1="9" y1="9" x2="15" y2="15" /></svg>
        )}
        <p className={`font-bold ${paymentResult.approved ? 'text-green-800' : 'text-red-800'}`}>
          {paymentResult.approved ? 'APPROVED' : 'DECLINED'}
        </p>
      </div>
    );
  }

  return (
    <ProcessingBody
      title={processing ? `Processing ${processingType?.replace('_', ' ')}...` : `Connecting to terminal...`}
      subtitle={processing ? (cancelling ? "Cancelling on terminal…" : WAITING) : 'Please wait'}
      onCancel={processing ? onCancel : null} cancelling={cancelling} testId="quickpay-processing" />
  );
}
